var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVias2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374,156c-76.1,0-138,61.91-138,138A138.25,138.25,0,0,0,247,348H144.17V296a10,10,0,0,0-20,0v62a10,10,0,0,0,10,10H257.56a138.5,138.5,0,0,0,9.26,12.89c.16.23.32.46.5.68L353.51,492H306.63a10,10,0,0,0,0,20H441.68a10,10,0,1,0,0-20h-47.2l86.68-111.09.1-.14A138.31,138.31,0,0,0,512,294C512,217.86,450.09,156,374,156Zm91.51,212.49-.36.46L374,485.75,283.78,370.16a10.35,10.35,0,0,0-.8-1.11,118,118,0,1,1,182.53-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.05,270.81a10,10,0,0,0-19,6.13,62,62,0,1,1-42.29-40.66A10,10,0,0,0,396.09,217a82,82,0,1,0,56,53.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.07,238.1,432,238a10,10,0,1,0-14.14,14.14l.09.09a10,10,0,1,0,14.14-14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.33,420H10a10,10,0,0,0,0,20H224.33v62a10,10,0,0,0,20,0V430A10,10,0,0,0,234.33,420Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.48,0a10,10,0,0,0-10,10V82H10a10,10,0,0,0,0,20H182.48a10,10,0,0,0,10-10V10A10,10,0,0,0,182.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.85,154H11a10,10,0,0,0,0,20H76.85V348H11a10,10,0,0,0,0,20H86.85a10,10,0,0,0,10-10V164A10,10,0,0,0,86.85,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.24,253.93a10,10,0,1,0,2.93,7.07A10.08,10.08,0,0,0,141.24,253.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,154H134.17a10,10,0,0,0-10,10V219.5a10,10,0,0,0,20,0V174H256a10,10,0,0,0,0-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,0a10,10,0,0,0-10,10V82H240.8V10a10,10,0,0,0-20,0V92a10,10,0,0,0,10,10L400,102a10,10,0,0,0,10-10V10A10,10,0,0,0,400,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502,82H458V10a10,10,0,0,0-20,0V92a10,10,0,0,0,10,10h54a10,10,0,0,0,0-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502,154H470.42a10,10,0,0,0,0,20H502a10,10,0,0,0,0-20Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias2);
export default __webpack_public_path__ + "static/media/Vias2.9bca71c46c923da5c5d9eb106a7b2359.svg";
export { ForwardRef as ReactComponent };